/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentUserApiToken } from "../../slices/currentUser/currentUserSlice";
import {
    m11ReportContainerFoiChanged, m11ReportContainerResourceChanged,
    m11ReportSection02FoiChanged, m11ReportSection02ResourceChanged, selectM11ReportContainerFoi,
    selectM11ReportContainerResource, selectM11ReportSection02Foi, selectM11ReportSection02Resource,
    selectM11ResearchStudyResource
} from "../../slices/m11ReportAuthoringTool/m11ReportAuthoringToolSlice";
import { useEffect, useState, useImperativeHandle, forwardRef } from "react";
import jsonEquals from "../../functions/jsonEquals";
import getIdFromReference from "../../functions/getIdFromReference";
import loadResource from "../m11ReportFunctions/loadResource";
import TextDivEntry from "./TextDivEntry";
import CodeEntry from "../../datatypeComponents/CodeEntry";
import saveM11Changes from "../../functions/saveM11ChangesAPI";
import { selectM11ResearchStudyFoi } from "../../slices/m11StepCount/m11StepCountSlice";
import { validateStep } from "../../functions/validateM11ReportAPI";

const saveIntroductionChanges = async (dispatch, apiToken, m11ResearchStudyFoi,
    section02State, setAlertModalState, setStartingSection02State) => {

    let changesStates = {
        section02State: section02State
    };
    let response = await saveM11Changes(apiToken, 19, m11ResearchStudyFoi, changesStates);
    if (response?.success) {
        if (response.m11ReportContainerResource) {
            dispatch(m11ReportContainerResourceChanged(response.m11ReportContainerResource));
        }
        if (response.m11ReportSection02Resource) {
            dispatch(m11ReportSection02ResourceChanged(response.m11ReportSection02Resource));
        }
        setStartingSection02State(JSON.parse(JSON.stringify(section02State)));
    } else {
        if (response.error) {
            alert(response.error);
        }
    }
};

const M11Step019Introduction = forwardRef(({ theM11ResearchStudyFoi, setAlertModalState }, ref) => {

    const dispatch = useDispatch();
    const apiToken = useSelector(selectCurrentUserApiToken);
    const m11ResearchStudyResource = useSelector(selectM11ResearchStudyResource);
    const m11ReportContainerFoi = useSelector(selectM11ReportContainerFoi);
    const m11ReportContainerResource = useSelector(selectM11ReportContainerResource);
    const m11ReportSection02Foi = useSelector(selectM11ReportSection02Foi);
    const m11ReportSection02Resource = useSelector(selectM11ReportSection02Resource);
    const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

    const [section02State, setSection02State] = useState({
        "section21Status": "empty", "section21Xhtml": "",
        "lumpOrSplit": "",
        "section22Status": "empty", "section22Xhtml": "",
        "trialInterventionStatus": "empty", "trialInterventionXhtml": "",
        "trialProceduresStatus": "empty", "trialProceduresXhtml": "",
        "otherStatus": "empty", "otherXhtml": "",
        "section222Status": "empty", "section222Xhtml": "",
        "section223Status": "empty", "section223Xhtml": ""
    });
    const [startingSection02State, setStartingSection02State] = useState({
        "section21Status": "empty", "section21Xhtml": "",
        "lumpOrSplit": "",
        "section22Status": "empty", "section22Xhtml": "",
        "trialInterventionStatus": "empty", "trialInterventionXhtml": "",
        "trialProceduresStatus": "empty", "trialProceduresXhtml": "",
        "otherStatus": "empty", "otherXhtml": "",
        "section222Status": "empty", "section222Xhtml": "",
        "section223Status": "empty", "section223Xhtml": ""
    });
    const [initialCalculationNeeded, setInitialCalculationNeeded] = useState(false);
    
    useImperativeHandle(ref, () => ({
        unsavedChanges: (m11ResearchStudyResource && !jsonEquals(section02State, startingSection02State)),
        async saveAllChanges() {
            await saveIntroductionChanges(dispatch, apiToken, m11ResearchStudyFoi,
                section02State, setAlertModalState, setStartingSection02State);
        }
    }));

    useEffect(() => {
        if (m11ResearchStudyResource?.id) {
            let m11ReportFoi = "";
            if (m11ResearchStudyResource.relatesTo?.length > 0) {
                for (let relatesTo of m11ResearchStudyResource.relatesTo) {
                    if (relatesTo.type?.coding?.[0]?.code === "supported-with" && relatesTo.type.text === "M11 Report" &&
                        relatesTo.targetReference) {
                        m11ReportFoi = getIdFromReference(relatesTo.targetReference);
                    }
                }
            }
            if (m11ReportFoi && !isNaN(m11ReportFoi) && m11ReportFoi !== m11ReportContainerFoi) {
                dispatch(m11ReportContainerFoiChanged(m11ReportFoi));
            } else {
                setInitialCalculationNeeded(true);
            }
        }
    }, [m11ResearchStudyResource]);

    useEffect(() => {
        if (initialCalculationNeeded === true) {
            let startingData = {
                "section21Status": "empty", "section21Xhtml": "",
                "lumpOrSplit": "",
                "section22Status": "empty", "section22Xhtml": "",
                "trialInterventionStatus": "empty", "trialInterventionXhtml": "",
                "trialProceduresStatus": "empty", "trialProceduresXhtml": "",
                "otherStatus": "empty", "otherXhtml": "",
                "section222Status": "empty", "section222Xhtml": "",
                "section223Status": "empty", "section223Xhtml": "", "loaded": true
            };
            setSection02State(startingData);
            setStartingSection02State(startingData);
        }
    }, [initialCalculationNeeded]);

    useEffect(() => {
        if (m11ReportContainerFoi && !isNaN(m11ReportContainerFoi)) {
            loadResource(m11ReportContainerFoi, "M11ReportContainer", apiToken, dispatch);
        }
    }, [m11ReportContainerFoi]);

    useEffect(() => {
        if (m11ReportContainerResource && Object.keys(m11ReportContainerResource).length > 0) {
            if (m11ReportContainerResource.section?.[2]?.entry?.length) {
                let m11ReportSection002Foi = getIdFromReference(m11ReportContainerResource.section[2].entry[0]);
                if (m11ReportSection002Foi && !isNaN(m11ReportSection002Foi) &&
                    m11ReportSection002Foi !== m11ReportSection02Foi) {
                    dispatch(m11ReportSection02FoiChanged(m11ReportSection002Foi));
                } else {
                    setInitialCalculationNeeded(true);
                }
            } else {
                setInitialCalculationNeeded(true);
            }
        }
    }, [m11ReportContainerResource]);

    useEffect(() => {
        if (m11ReportSection02Foi && !isNaN(m11ReportSection02Foi)) {
            loadResource(m11ReportSection02Foi, "M11ReportSection02", apiToken, dispatch);
        }
    }, [m11ReportSection02Foi]);

    useEffect(() => {
        if (m11ReportSection02Resource && Object.keys(m11ReportSection02Resource).length > 0) {
            let startingData = {
                "section21Status": "empty", "section21Xhtml": "",
                "lumpOrSplit": "",
                "section22Status": "empty", "section22Xhtml": "",
                "trialInterventionStatus": "empty", "trialInterventionXhtml": "",
                "trialProceduresStatus": "empty", "trialProceduresXhtml": "",
                "otherStatus": "empty", "otherXhtml": "",
                "section222Status": "empty", "section222Xhtml": "",
                "section223Status": "empty", "section223Xhtml": "", "loaded": true
            };
            if (m11ReportSection02Resource.section?.[0]?.section?.length > 0) {
                if (m11ReportSection02Resource.section[0].section[0]?.text?.div &&
                    m11ReportSection02Resource.section[0].section[0].text.status !== "empty") {
                    startingData.section21Status = m11ReportSection02Resource.section[0].section[0].text.status;
                    startingData.section21Xhtml = m11ReportSection02Resource.section[0].section[0].text.div;
                }
                if (m11ReportSection02Resource.section[0].section[1]?.text?.div &&
                    m11ReportSection02Resource.section[0].section[1].text.status !== "empty") {
                    startingData.section22Status = m11ReportSection02Resource.section[0].section[1].text.status;
                    startingData.section22Xhtml = m11ReportSection02Resource.section[0].section[1].text.div;
                    startingData.lumpOrSplit = "Lump";
                }
                if (m11ReportSection02Resource.section[0].section[1]?.section?.length > 0) {
                    if (m11ReportSection02Resource.section[0].section[1].section[0]?.section?.[0]?.text?.div &&
                        m11ReportSection02Resource.section[0].section[1].section[0].section[0].text.status !== "empty") {
                        startingData.trialInterventionStatus = m11ReportSection02Resource.section[0].section[1].section[0].section[0].text.status;
                        startingData.trialInterventionXhtml = m11ReportSection02Resource.section[0].section[1].section[0].section[0].text.div;
                        startingData.lumpOrSplit = "Split";
                    }
                    if (m11ReportSection02Resource.section[0].section[1].section[0]?.section?.[1]?.text?.div &&
                        m11ReportSection02Resource.section[0].section[1].section[0].section[1].text.status !== "empty") {
                        startingData.trialProceduresStatus = m11ReportSection02Resource.section[0].section[1].section[0].section[1].text.status;
                        startingData.trialProceduresXhtml = m11ReportSection02Resource.section[0].section[1].section[0].section[1].text.div;
                    }
                    if (m11ReportSection02Resource.section[0].section[1].section[0]?.section?.[2]?.text?.div &&
                        m11ReportSection02Resource.section[0].section[1].section[0].section[2].text.status !== "empty") {
                        startingData.otherStatus = m11ReportSection02Resource.section[0].section[1].section[0].section[2].text.status;
                        startingData.otherXhtml = m11ReportSection02Resource.section[0].section[1].section[0].section[2].text.div;
                    }
                    if (m11ReportSection02Resource.section[0].section[1].section[1]?.text?.div &&
                        m11ReportSection02Resource.section[0].section[1].section[1].text.status !== "empty") {
                        startingData.section222Status = m11ReportSection02Resource.section[0].section[1].section[1].text.status;
                        startingData.section222Xhtml = m11ReportSection02Resource.section[0].section[1].section[1].text.div;
                    }
                    if (m11ReportSection02Resource.section[0].section[1].section[2]?.text?.div &&
                        m11ReportSection02Resource.section[0].section[1].section[2].text.status !== "empty") {
                        startingData.section223Status = m11ReportSection02Resource.section[0].section[1].section[2].text.status;
                        startingData.section223Xhtml = m11ReportSection02Resource.section[0].section[1].section[2].text.div;
                    }
                }
                setSection02State(startingData);
                setStartingSection02State(startingData);
            } else {
                setInitialCalculationNeeded(true);
            }
        }
    }, [m11ReportSection02Resource]);

    return <div>
        <h3>Complete Section 2 Introduction</h3>
        {!(m11ReportSection02Resource?.id || m11ReportContainerResource?.id) &&
            <h1 style={{ color: "red" }}>Please complete Step 5 (Complete Title Page) before filling in M11 Report Section details.</h1>
        }
        {section02State.loaded && <>
            <h4 style={{ marginBottom: "0px" }}>Revise the Section 2.1 Purpose of Trial summary as needed.</h4>
            <TextDivEntry elementName="section21Xhtml"
                startingValue={section02State.section21Xhtml}
                setResourceState={setSection02State} />
            <h4 style={{ marginBottom: "0px" }}>Revise the Section 2.2 Assessment of Risks and Benefits summary as needed.</h4>
            {section02State.lumpOrSplit === "Lump" ?
                <TextDivEntry elementName="section22Xhtml"
                    startingValue={section02State.section22Xhtml}
                    setResourceState={setSection02State} />
                :
                section02State.lumpOrSplit === "Split" ?
                    <>
                        <h5 style={{ marginBottom: "0px" }}>Revise the Trial Intervention Risk Summary and Mitigation Strategy as needed.</h5>
                        <TextDivEntry elementName="trialInterventionXhtml"
                            startingValue={section02State.trialInterventionXhtml}
                            setResourceState={setSection02State} />
                        <h5 style={{ marginBottom: "0px" }}>Revise the Trial Procedures Risk Summary and Mitigation Strategy as needed.</h5>
                        <TextDivEntry elementName="trialProceduresXhtml"
                            startingValue={section02State.trialProceduresXhtml}
                            setResourceState={setSection02State} />
                        <h5 style={{ marginBottom: "0px" }}>Revise the Other Risk Summary and Mitigation Strategy as needed.</h5>
                        <TextDivEntry elementName="otherXhtml"
                            startingValue={section02State.otherXhtml}
                            setResourceState={setSection02State} />
                        <h5 style={{ marginBottom: "0px" }}>Revise the Benefit Summary as needed.</h5>
                        <TextDivEntry elementName="section222Xhtml"
                            startingValue={section02State.section222Xhtml}
                            setResourceState={setSection02State} />
                        <h5 style={{ marginBottom: "0px" }}>Revise the Overall Risk-Benefit Assessment as needed.</h5>
                        <TextDivEntry elementName="section223Xhtml"
                            startingValue={section02State.section223Xhtml}
                            setResourceState={setSection02State} />
                    </>
                    :
                    <>
                        <h5 style={{ marginBottom: "0px" }}>DECIDE whether to summarize as one section (Lump) or multiple subsections (Split).</h5>
                        <CodeEntry elementName='lumpOrSplit' fieldLabel='Lump or Split'
                            startingValue={section02State.lumpOrSplit} setResourceState={setSection02State}
                            allowedValues={["Lump", "Split"]} />
                    </>
            }
        </>}
    </div >
});

const M11Step019IntroductionHelperText = <div>
    <h3>Complete Section 2 Introduction</h3>
    <div style={{ textAlign: "left" }}>
        <p>Enter data for Section 2.1 Purpose of Trial.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>Explain why the trial is needed, and why the research questions being asked are important. Do not restate the objectives or estimands. Do not restate the IB; rather, cross reference to the IB as applicable to the description.</p>
        </div>
        <p>Enter data for Section 2.2 Assessment of Risks and Benefits.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>Include an assessment of known and potential risks and benefits, if any, as a result of participating in the trial from the perspective of an individual participant, including the basis of the risk (e.g., nonclinical trials or prior clinical trials).</p>
            <p>This section may be structured under one single heading 2.2 Assessment of Risks and Benefits, or if applicable under 3 subheadings as 2.2.1 Risk Summary and Mitigation Strategy, 2.2.2 Benefit Summary and 2.2.3 Overall Risk-Benefit Assessment.</p>
            <p>DECIDE WHETHER TO USE 1 SECTION OR 3 SUBSECTIONS.  If using 1 section, enter the entire summary there and 'Save All Changes'.</p>
            <p>For Section 2.2.1 Risk Summary and Mitigation Strategy:</p>
            <div style={{ marginLeft: "24px" }} >
                <p>For Trial Intervention: Describe risks related to trial-specific treatments and interventions. For the protocol, focus on the relevant key risks for this trial. Provide a brief description of strategies to mitigate identified risks or provide a cross reference to the relevant protocol section.</p>
                <p>For Trial Procedures: Describe risks associated with the design (e.g., placebo arm) and procedures specific to this trial (e.g., biopsies), and any measures to control or mitigate the risks. Provide a brief description of strategies to mitigate identified risks or provide a cross reference to the relevant protocol section. This is not intended to be an exhaustive list of all possible risks associated with trial procedures but should focus on the unique risks inherent in the design or less common or high-risk procedures.</p>
                <p>For Other: Consider risks associated with other items (e.g., challenge agents, imaging agents, medical devices). This could include discussion of risk mitigation for special populations, if not described elsewhere. Insert a line for each, as needed.</p>
            </div>
            <p>For Section 2.2.2 Benefit Summary: The benefit summary should describe any physical, psychological, social, or other potential benefits to individual participants as a result of participating in the trial, addressing immediate potential benefits and/or long-range potential benefits. Clearly state if no benefits to an individual participant can be anticipated, or if potential benefits are unknown. For early clinical trials such as Phase 1 or trials in healthy participants, benefits for an individual participant (other than those of altruism) are expected to be minimal. Benefits to society in general may also be included but should be described separately from the individual participant perspective.</p>
            <p>For Section 2.2.3 Overall Risk-Benefit Assessment: Provide a succinct, concluding statement on the perceived balance between risks that have been identified from cumulative safety data, protocol procedures, and anticipated efficacy/benefits within the context of the proposed trial.</p>
        </div>
        <p>Click the 'Save All Changes' button.</p>
    </div>
</div>

// eslint-disable-next-line no-empty-pattern
const M11Step019IntroductionValidationCheck = ({ }) => {

  const apiToken = useSelector(selectCurrentUserApiToken);
  const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

  const [validationCheckState, setValidationCheckState] = useState({});

  useEffect(() => {
    if (m11ResearchStudyFoi) {
      validateStep(apiToken, 19, m11ResearchStudyFoi,
        setValidationCheckState)
    }
  }, [m11ResearchStudyFoi]);

  return <div>{validationCheckState?.success && <div>
        <h4>Step 19 (Complete Section 2 Introduction) {validationCheckState.step19numberOfChecks} issues checked. {validationCheckState.step19numberPassed} passed. {validationCheckState.step19numberFailed} failed.</h4>
        <p>Section 2 heading is 'INTRODUCTION': {validationCheckState.resultCheckSection2Heading}</p>
        <p>Section 2 INTRODUCTION does not have text: {validationCheckState.resultCheckSection2Text}</p>
        <p>Section 2.1 heading is 'Purpose of Trial': {validationCheckState.resultCheckSection21Heading}</p>
        <p>Section 2.1 Purpose of Trial has content: {validationCheckState.resultCheckSection21Content}</p>
        <p>Section 2.2 heading is 'Assessment of Risks and Benefits': {validationCheckState.resultCheckSection22Heading}</p>
        <p>Section 2.2 Assessment of Risks and Benefits has content or 3 subheadings: {validationCheckState.resultCheckSection22Content}</p>
        <p>If present, Section 2.2.1 heading is 'Risk Summary and Mitigation Strategy': {validationCheckState.resultCheckSection221Heading}</p>
        <p>If present, Section 2.2.1 Risk Summary and Mitigation Strategy has content: {validationCheckState.resultCheckSection221Content}</p>
        <p>If present, Section 2.2.2 heading is 'Benefit Summary': {validationCheckState.resultCheckSection222Heading}</p>
        <p>If present, Section 2.2.2 Benefit Summary has content: {validationCheckState.resultCheckSection222Content}</p>
        <p>If present, Section 2.2.3 heading is 'Overall Risk-Benefit Assessment': {validationCheckState.resultCheckSection223Heading}</p>
        <p>If present, Section 2.2.3 Overall Risk-Benefit Assessment has content: {validationCheckState.resultCheckSection223Content}</p>
    </div>}  </div>
}

export default M11Step019Introduction;
export { M11Step019IntroductionHelperText, M11Step019IntroductionValidationCheck };